import { Controller } from "@hotwired/stimulus"
import { post, get, patch, destroy } from "@rails/request.js"

export default class extends Controller {
  static values = { 
    url: String,
    method: String,
    params: Object
  }



  async submit(event) {
    event.preventDefault()

    try {
      const response = await this.makeRequest(event)

      if (response.ok) {
        this.handleSuccess(response)
      } else {
        this.handleError(response)
      }
    } catch (error) {
      this.handleError(error)
    }
  }

  async select(event) {
    const selectElement = event.target
    const selectedOption = selectElement.options[selectElement.selectedIndex]
    const url = this.buildSelectUrl(selectedOption)
    window.location.href = url
  }

  buildSelectUrl(selectedOption) {
    const baseUrl = this.urlValue
    let params = { ...this.paramsValue }
    
    // Add the selected value to params if option has data attributes
    if (selectedOption && selectedOption.value) {
      const requestKey = selectedOption.dataset.requestKey
      const requestValue = selectedOption.dataset.requestValue || selectedOption.value
      
      if (requestKey && requestValue) {
        params[requestKey] = requestValue
      }
    }
    
    // Build query string
    const queryString = new URLSearchParams(params).toString()
    if (queryString) {
      const separator = baseUrl.includes('?') ? '&' : '?'
      return `${baseUrl}${separator}${queryString}`
    }
    
    return baseUrl
  }

  async makeRequest(event) {
    const method = this.methodValue || 'post'
    const url = this.urlValue
    let params = this.paramsValue || {}

    // If event target is a checkbox, add its checked state to params
    if (event && event.target && event.target.type === 'checkbox') {
      params = { ...params, checked: event.target.checked }
    }

    const requestMethods = { post, get, patch, delete: destroy }
    const requestMethod = requestMethods[method.toLowerCase()]

    if (!requestMethod) {
      throw new Error(`Unsupported HTTP method: ${method}`)
    }

    // GET requests use query params, others use body
    const options = method.toLowerCase() === 'get'
      ? { query: params, responseKind: 'turbo-stream' }
      : { body: params, responseKind: 'turbo-stream' }

    return await requestMethod(url, options)
  }

  handleSuccess(response) {
    this.dispatch('success', { 
      detail: { response, controller: this } 
    })
  }

  async selectTurbo(event) {
    const selectElement = event.target
    const selectedOption = selectElement.options[selectElement.selectedIndex]

    if (!selectedOption.value) return

    // Set params from selected option so makeRequest picks them up
    const requestKey = selectedOption.dataset.requestKey
    const requestValue = selectedOption.dataset.requestValue || selectedOption.value
    if (requestKey) {
      this.paramsValue = { ...this.paramsValue, [requestKey]: requestValue }
    }

    this.makeRequest(event)
  }

  handleError(error) {
    console.error('Request failed:', error)
    this.dispatch('error', { 
      detail: { error, controller: this } 
    })
  }
}
